import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import ResizingTextareaActions from 'flux/actions/cuesheet/ResizingTextareaActions';
import {
  ColorRGBs,
  RTEFontSizeArray,
} from 'flux/stores/cuesheet/CuesheetConstants';
import classnames from 'classnames';
import { convertToRaw, EditorState, KeyBindingUtil, Modifier } from 'draft-js';
import {
  applyInlineFormattingToEditorState,
  createEditorStateFromRawRTEState,
} from 'shared/lib/rteHelper';
import { Editor } from 'react-draft-wysiwyg';
import draftUtils from '@shoflo-rundown/draft-js-utils';
import { fromJS } from 'immutable';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import RTEActions from 'flux/actions/RTEActions';

const { hasCommandModifier } = KeyBindingUtil;
const CustomColorConfig = ColorRGBs;

class FontCase extends React.Component {
  constructor(props) {
    super(props);

    this.toggleUpperCase = this.toggleUpperCase.bind(this);

    this.state = {
      isUppercaseEnabled: false,
    };

    this.nextStyleMap = {
      UPPERCASE: 'LOWERCASE',
      LOWERCASE: 'UPPERCASE',
    };
  }

  componentDidUpdate(prevProps) {
    const { editorState } = this.props;
    if (editorState && editorState !== prevProps.editorState) {
      const selectedText = this.getSelectedText(editorState);
      const inlineStyle = editorState.getCurrentInlineStyle();

      const isUppercaseEnabled = inlineStyle.isEmpty()
        ? selectedText && selectedText === selectedText.toUpperCase()
        : inlineStyle.has('UPPERCASE');

      this.setState({
        isUppercaseEnabled,
      });
    }
  }

  getSelectedText(editorState) {
    const selection = editorState.getSelection();
    const contentState = editorState.getCurrentContent();
    const currentContent = contentState.getBlockForKey(selection.getStartKey());
    const selectedText = currentContent
      .getText()
      .slice(selection.getStartOffset(), selection.getEndOffset());

    return selectedText;
  }

  getNextStyle(currentStyle, selectedText) {
    const isUppercaseText =
      selectedText && selectedText === selectedText.toUpperCase();

    let nextStyle = 'UPPERCASE';

    if (currentStyle.isEmpty() && isUppercaseText) {
      nextStyle = this.nextStyleMap.UPPERCASE;
    }
    if (currentStyle.has('LOWERCASE')) {
      nextStyle = this.nextStyleMap.LOWERCASE;
    }
    if (currentStyle.has('UPPERCASE')) {
      nextStyle = this.nextStyleMap.UPPERCASE;
    }

    return nextStyle;
  }

  toggleUpperCase() {
    const { editorState, onChange } = this.props;
    const selection = editorState.getSelection();
    const currentStyle = editorState.getCurrentInlineStyle();
    const selectedText = this.getSelectedText(editorState);

    const nextInlineStyle = this.getNextStyle(currentStyle, selectedText);
    /**
     * If the selection is collapsed, toggle the specified style on or off and
     * set the result as the new inline style override. This will then be
     * used as the inline style for the next character to be inserted.
     */
    if (selection.isCollapsed()) {
      const nextEditorState = EditorState.setInlineStyleOverride(
        editorState,
        currentStyle.has(nextInlineStyle)
          ? currentStyle.remove(nextInlineStyle)
          : currentStyle.add(nextInlineStyle),
      );

      return onChange(nextEditorState);
    }

    /**
     * If characters are selected, immediately apply or remove the
     * inline style on the document state itself.
     */
    const content = editorState.getCurrentContent();
    let newContent;

    const styleToRemove = this.nextStyleMap[nextInlineStyle];

    if (currentStyle.has(styleToRemove)) {
      newContent = Modifier.removeInlineStyle(
        content,
        selection,
        styleToRemove,
      );
    } else {
      newContent = Modifier.applyInlineStyle(
        content,
        selection,
        nextInlineStyle,
      );
    }

    onChange(EditorState.push(editorState, newContent, 'change-inline-style'));
  }

  render() {
    const classNames = classnames(
      'rdw-option-wrapper',
      'rte-toolbar-item',
      'rte-font-case-option',
      { 'rdw-option-active': this.state.isUppercaseEnabled },
    );
    return (
      <div className="rdw-fontcase-wrapper" aria-label="rdw-fontcase-control">
        <div className={classNames} onClick={this.toggleUpperCase}>
          <span className="small-icon">
            <Icon name="font" />
          </span>
          <span className="icon">
            <Icon name="font" />
          </span>
        </div>
      </div>
    );
  }
}

FontCase.propTypes = {
  onChange: React.PropTypes.func,
  editorState: React.PropTypes.object,
};

export default React.createClass({
  mixins: [Reflux.ListenerMixin, PureRenderMixin],

  propTypes: {
    resize: React.PropTypes.bool,
    rteState: React.PropTypes.object,
    minHeight: React.PropTypes.number,
    height: React.PropTypes.number,
    editorClassName: React.PropTypes.string,
    toolbarClassName: React.PropTypes.string,
    displayToolbar: React.PropTypes.bool,
    autoFocus: React.PropTypes.bool,
    onContentChange: React.PropTypes.func,
    onExternalContentChange: React.PropTypes.func,
    onScroll: React.PropTypes.func,
    toolbarOnFocus: React.PropTypes.bool,
    disableBlur: React.PropTypes.bool,
  },

  getInitialState() {
    return {};
  },

  getDefaultProps() {
    return {
      displayToolbar: false,
      resize: true,
      readOnly: false,
      toolbarOnFocus: true,
      disableBlur: false,
    };
  },

  componentDidMount() {
    this._setupResizing();
    if (this.props.autoFocus && this._rteEditor) this._rteEditor.focusEditor();
    this.listenTo(
      RTEActions.applyInlineFormatting,
      this._applyInlineFormatting,
    );
  },

  componentWillReceiveProps(nextProps) {
    const { readOnly } = nextProps;
    if (readOnly && readOnly !== this.props.readOnly) {
      this.setState({ editorState: null });
    }
  },

  componentWillUnmount() {
    if (this.state.editorState && this.props.onWillUnmount) {
      const currentContentState = this.state.editorState.getCurrentContent();
      const rawContentState = convertToRaw(currentContentState);
      this.props.onWillUnmount(fromJS(rawContentState));
    }
  },

  render() {
    let {
      wrapperClassName,
      toolbarClassName,
      editorClassName,
      displayToolbar,
      rteState,
      // minHeight,
      height,
      partialCell,
      readOnly,
      placeholder,
      toolbarOnFocus,
      viewType,
      scrollTop,
      onScroll,
    } = this.props;

    let editorNodeProps = {
      ref: (e) => {
        if (!e) return;

        this._rteEditorWrapper = e.getWrapperRef();
        this._rteEditorWrapper.setAttribute('aria-label', 'RTE Editor Wrapper');

        if (scrollTop) this._rteEditorWrapper.scrollTop = scrollTop;
        if (onScroll) this._rteEditorWrapper.onscroll = onScroll;

        this._rteEditor = e;
      },
      wrapperClassName: classnames('rte-wrapper', wrapperClassName),
      placeholder,
      toolbarOnFocus,
      readOnly,
      onTab: this._handleTab,
      toolbarClassName: classnames('rte-toolbar', toolbarClassName, {
        'rte-hide-toolbar': !displayToolbar,
      }),
      editorClassName: classnames('rte-editor', editorClassName),
      onEditorStateChange: this._handleChange,
      onBlur: this._handleBlur,
      onFocus: this._handleFocusChange,
    };

    //initialize editor state based on rteState prop
    if (rteState && typeof rteState === 'object' && rteState.get('blocks')) {
      editorNodeProps.editorState = createEditorStateFromRawRTEState(
        rteState.toJS(),
        true,
      );
    } else {
      //if we don't set editorState to null when there is no rteState, the editor wont rerender
      editorNodeProps.editorState = null;
    }

    //if changes have been made, editor state is based on component state
    if (this.state.editorState) {
      editorNodeProps.editorState = this.state.editorState;
    }

    //If there is an empty editor state, the editor will use the placeholder text
    editorNodeProps.defaultEditorState = EditorState.createEmpty();

    if (!editorNodeProps.editorState && !editorNodeProps.defaultEditorState)
      return <div />;

    const editorStyle = { minHeight: height };

    const wrapperStyle = {};

    if (partialCell) {
      delete editorStyle.minHeight;
      wrapperStyle.minHeight = height;
    }

    let toolbarStyle = {};

    if (viewType === 'featured') {
      editorStyle.height = height;
    }

    if (viewType === 'prompter') {
      toolbarStyle = this.props.toolbarStyle;
    }

    /**
     * if Rundown uppercase flag is enabled we want to not show the redo toolbar item
     * to keep all the toolbar items to two rows
     */
    const historyOptions = ['undo'];

    return (
      <div
        data-testid="rte-editor-wrapper"
        style={wrapperStyle}
        ref="wrapper"
        aria-label="Editor Wrapper"
        onClick={this._focusEditor}
        onKeyDown={(e) => {
          const enterKey = 13;

          let { isEditing, onKeyDown } = this.props;

          if (isEditing && e.keyCode === enterKey && hasCommandModifier(e)) {
            this._handleBlur(this.state.editorState);
            if (onKeyDown) onKeyDown();
          }
        }}
      >
        <Editor
          data-testid="rte-cell-editor"
          {...editorNodeProps}
          editorStyle={editorStyle}
          toolbarStyle={toolbarStyle}
          spellCheck
          toolbar={{
            options: [
              'inline',
              'fontSize',
              'colorPicker',
              'list',
              'textAlign',
              'link',
              'remove',
              'history',
            ],
            inline: {
              options: ['bold', 'italic', 'underline'],
              bold: {
                className: 'rte-toolbar-item',
              },
              italic: {
                className: 'rte-toolbar-item',
              },
              underline: {
                className: 'rte-toolbar-item',
              },
            },
            textAlign: {
              inDropdown: true,
              options: ['left', 'center', 'right'],
              left: {
                className: 'rte-toolbar-item',
              },
              center: {
                className: 'rte-toolbar-item',
              },
              right: {
                className: 'rte-toolbar-item',
              },
              justify: {
                className: 'rte-toolbar-item',
              },
            },
            fontSize: {
              options: RTEFontSizeArray,
            },
            colorPicker: {
              className: 'rte-toolbar-item',
              colors: CustomColorConfig,
            },
            remove: {
              className: 'rte-toolbar-item',
            },
            history: {
              options: historyOptions,
              undo: {
                className: 'rte-toolbar-item',
              },
              redo: {
                className: 'rte-toolbar-item',
              },
            },
            link: {
              options: ['link', 'unlink'],
              link: {
                className: 'rte-toolbar-item',
              },
              unlink: {
                className: 'rte-toolbar-item',
              },
            },
            list: {
              options: ['unordered'],
              unorderered: {
                classname: 'rte-toolbar-item',
              },
            },
          }}
          toolbarCustomButtons={[<FontCase />]}
        />
      </div>
    );
  },

  _handleFocusChange(e) {
    this._editorHasFocus = e.target.className === 'public-DraftEditor-content';
  },

  _focusEditor() {
    if (this._rteEditor) {
      this._rteEditor.focusEditor();
      this._editorHasFocus = true;
    }
  },

  _applyInlineFormatting(styles) {
    let editorState = this._rteEditor.state.editorState;

    editorState = applyInlineFormattingToEditorState(editorState, styles);

    this._handleChange(editorState);
  },

  _handleChange(editorState) {
    //If we have already blurred out, don't fire this handler
    //...when you use the tab key to blur out, this handler is fired _after_ the
    //... editor has blurred and lost focus...we don't want that
    if (this._blurred) return;

    if (!this._editorHasFocus) {
      this._focusEditor();
    }

    const { onExternalContentChange } = this.props;

    /**
     * Why do we need onExternalContentChange?
     *
     * This allows us to monitor the state changes from outside
     * of the rte component and save the content via different triggers
     * other than the cell losing focus.
     */
    if (onExternalContentChange && editorState) {
      const CurrentContentState = editorState.getCurrentContent();
      onExternalContentChange(fromJS(convertToRaw(CurrentContentState)));
    }
    this.setState({ editorState });
  },

  _handleTab(e) {
    if (this.props.onTab) this.props.onTab(e);
    this._handleBlur();
  },

  _handleBlur() {
    let { editorState } = this.state;
    let { onContentChange, disableBlur, rowId } = this.props;
    /**
     * If blur is disabled then it means
     * another source to trigger the save.
     * For instance, a save button.
     */
    if (disableBlur) return;

    this.setState({ editorState: null });

    if (!editorState) return;

    const currentContentState = editorState.getCurrentContent();

    if (onContentChange) {
      onContentChange(
        fromJS(
          draftUtils.replaceTextInRawRTEState(
            convertToRaw(currentContentState),
            /\t/g,
            '   ',
          ),
        ),
        rowId,
      );
      this._blurred = true;
    }

    ResizingTextareaActions.clearHeight();
  },

  getValue() {
    const { editorState } = this.state;

    const contentState = editorState.getCurrentContent();

    return fromJS(convertToRaw(contentState));
  },

  _setupResizing() {
    if (!this.props.resize) return;

    this._getRTEDOMNode().addEventListener('keyup', this._resize);

    this._resize(0);
  },

  _tearDownResizing() {
    if (!this.props.resize) return;

    this._getRTEDOMNode().removeEventListener('keyup', this._resize);
  },

  _getNumericValueCSS(element, cssProperty) {
    return parseInt(
      window.getComputedStyle(element, null).getPropertyValue(cssProperty),
      10,
    );
  },

  /**
   * Resize the rte based on the contents...
   */
  _resize() {
    let rteNode = this._getRTEDOMNode(),
      rteHeightNode =
        rteNode.children && rteNode.children.length > 1
          ? rteNode.children[1]
          : rteNode,
      resizeHeightState = rteHeightNode.scrollHeight;

    let paddingOffset =
      this._getNumericValueCSS(rteHeightNode, 'padding-top') +
      this._getNumericValueCSS(rteHeightNode, 'padding-bottom');

    let resizeHeight = resizeHeightState - paddingOffset;

    //Resize to the highest value, either the size of the text area or the cell height
    ResizingTextareaActions.setHeight(resizeHeight);
  },

  _getRTEDOMNode() {
    return ReactDOM.findDOMNode(this._rteEditor);
  },
});
